/* Mobilno dugme SORTIRAJ (Jeremić Satovi).
   Nativni select prosleđuje izbor postojećem sortiranju u mobilnom panelu (#SortBy-mobile),
   pa Dawn osveži proizvode preko AJAX-a i zadrži aktivne filtere.
   Ako panela nema, stranica se učita ponovo sa novim sort_by parametrom. */
(function () {
  if (window.__jscSortReady) return;
  window.__jscSortReady = true;

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('[data-jsc-sort]')) return;

    var target = document.getElementById('SortBy-mobile');
    if (target) {
      target.value = select.value;
      target.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  // Kad se sortira iz panela, dugme SORTIRAJ prati isti izbor
  document.addEventListener('input', function (event) {
    if (!event.target || event.target.id !== 'SortBy-mobile') return;
    document.querySelectorAll('[data-jsc-sort]').forEach(function (select) {
      select.value = event.target.value;
    });
  });
})();

/* Brend cipovi: posle AJAX filtriranja osvezi cipove (Dawn ne dira blokove bez .js-filter) */
(function () {
  if (window.__jscChipsReady) return;
  window.__jscChipsReady = true;

  var timer = null;
  function refresh() {
    var holder = document.querySelector('[data-jsc-brands]');
    if (!holder) return;
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', holder.getAttribute('data-section-id'));
    fetch(url.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-jsc-brands]');
        var current = document.querySelector('[data-jsc-brands]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  var grid = document.getElementById('ProductGridContainer');
  if (!grid) return;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  }).observe(grid, { childList: true });
})();